import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath, storagePath } from '../../../constants/defaultValues';
import { storage } from '../../../helpers/Firebase';
import { NotificationManager } from '../../../components/common/react-notifications';
import {
    HOSPITAL_EVALUATION_LIST,
    HOSPITAL_EVALUATION_DESTINATION,
    HOSPITAL_EVALUATION_AREA,
    HOSPITAL_EVALUATION_JOB,
    HOSPITAL_EVALUATION_CAPACITY_INSTALL,
    HOSPITAL_EVALUATION_INFRASTRUCTURE,
    HOSPITAL_EVALUATION_HUMAN_TALENT,
    HOSPITAL_EVALUATION_PRODUCTION,
    HOSPITAL_EVALUATION_AVAILABILITY,
    HOSPITAL_EVALUATION_ADD
} from "../../actions";

import {
    HospitalEvaluationListSuccess,
    HospitalEvaluationListError,
    HospitalEvaluationDestinationSuccess,
    HospitalEvaluationDestinationError,
    HospitalEvaluationAreaSuccess,
    HospitalEvaluationAreaError,
    HospitalEvaluationJobSuccess,
    HospitalEvaluationJobError,
    HospitalEvaluationCapacityInstallSuccess,
    HospitalEvaluationCapacityInstallError,
    HospitalEvaluationInfrastructureSuccess,
    HospitalEvaluationInfrastructureError,
    HospitalEvaluationHumanTalentSuccess,
    HospitalEvaluationHumanTalentError,
    HospitalEvaluationProductionSuccess,
    HospitalEvaluationProductionError,
    HospitalEvaluationAvailabilitySuccess,
    HospitalEvaluationAvailabilityError,
    HospitalEvaluationAddSuccess,
    HospitalEvaluationAddError
} from '../../actions';

export function* watchHospitalEvaluationList() {
    yield takeEvery(HOSPITAL_EVALUATION_LIST, onHospitalEvaluationList);
}

export function* watchHospitalEvaluationDestination() {
    yield takeEvery(HOSPITAL_EVALUATION_DESTINATION, onHospitalEvaluationDestination);
}

export function* watchHospitalEvaluationArea() {
    yield takeEvery(HOSPITAL_EVALUATION_AREA, onHospitalEvaluationArea);
}

export function* watchHospitalEvaluationJob() {
    yield takeEvery(HOSPITAL_EVALUATION_JOB, onHospitalEvaluationJob);
}

export function* watchHospitalEvaluationAdd() {
    yield takeEvery(HOSPITAL_EVALUATION_ADD, onHospitalEvaluationAdd);
}

export function* watchHospitalEvaluationCapacityInstall() {
    yield takeEvery(HOSPITAL_EVALUATION_CAPACITY_INSTALL, onHospitalEvaluationCapacityInstall);
}

export function* watchHospitalEvaluationInfrastructure() {
    yield takeEvery(HOSPITAL_EVALUATION_INFRASTRUCTURE, onHospitalEvaluationInfrastructure);
}

export function* watchHospitalEvaluationHumanTalent() {
    yield takeEvery(HOSPITAL_EVALUATION_HUMAN_TALENT, onHospitalEvaluationHumanTalent);
}

export function* watchHospitalEvaluationProduction() {
    yield takeEvery(HOSPITAL_EVALUATION_PRODUCTION, onHospitalEvaluationProduction);
}

export function* watchHospitalEvaluationAvailability() {
    yield takeEvery(HOSPITAL_EVALUATION_AVAILABILITY, onHospitalEvaluationAvailability);
}

function getToken(auth) {   
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

const onHospitalEvaluationListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'hospitalNetEvaluation/list', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
}

const onHospitalEvaluationDestinationAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'hospitalNetEvaluation/destination', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onHospitalEvaluationAreaAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'hospitalNetEvaluation/area', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onHospitalEvaluationJobAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'hospitalNetEvaluation/job', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onHospitalEvaluationAddAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'hospitalNetEvaluation/add', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onHospitalEvaluationCapacityInstallAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'hospitalNetEvaluation/capacityinstall', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onHospitalEvaluationInfrastructureAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'hospitalNetEvaluation/infrastructure', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onHospitalEvaluationHumanTalentAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'hospitalNetEvaluation/humantalent', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onHospitalEvaluationProductionAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'hospitalNetEvaluation/production', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onHospitalEvaluationAvailabilityAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'hospitalNetEvaluation/availability', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

function* onHospitalEvaluationList(data) {
    try {
        const response = yield call(onHospitalEvaluationListAsync, data.payload);
        yield put(HospitalEvaluationListSuccess(response.data));
    } catch (error) {
        yield put(HospitalEvaluationListError(error));
    }
}

function* onHospitalEvaluationDestination(data) {
    try {
        const response = yield call(onHospitalEvaluationDestinationAsync, data.payload);
        yield put(HospitalEvaluationDestinationSuccess(response.data));
    } catch (error) {
        yield put(HospitalEvaluationDestinationError(error));
    }
}

function* onHospitalEvaluationArea(data) {
    try {
        const response = yield call(onHospitalEvaluationAreaAsync, data.payload);
        yield put(HospitalEvaluationAreaSuccess(response.data));
    } catch (error) {
        yield put(HospitalEvaluationAreaError(error));
    }
}

function* onHospitalEvaluationJob(data) {
    try {
        const response = yield call(onHospitalEvaluationJobAsync, data.payload);
        yield put(HospitalEvaluationJobSuccess(response.data));
    } catch (error) {
        yield put(HospitalEvaluationJobError(error));
    }
}

function* onHospitalEvaluationAdd(data) {
    try {
        const response = yield call(onHospitalEvaluationAddAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(HospitalEvaluationAddSuccess(response.data));
    } catch (error) {
        yield put(HospitalEvaluationAddError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}

function* onHospitalEvaluationCapacityInstall(data) {
    try {
        const response = yield call(onHospitalEvaluationCapacityInstallAsync, data.payload);
        yield put(HospitalEvaluationCapacityInstallSuccess(response.data));
    } catch (error) {
        yield put(HospitalEvaluationCapacityInstallError(error));
    }
}

function* onHospitalEvaluationInfrastructure(data) {
    try {
        const response = yield call(onHospitalEvaluationInfrastructureAsync, data.payload);
        yield put(HospitalEvaluationInfrastructureSuccess(response.data));
    } catch (error) {
        yield put(HospitalEvaluationInfrastructureError(error));
    }
}

function* onHospitalEvaluationHumanTalent(data) {
    try {
        const response = yield call(onHospitalEvaluationHumanTalentAsync, data.payload);
        yield put(HospitalEvaluationHumanTalentSuccess(response.data));
    } catch (error) {
        yield put(HospitalEvaluationHumanTalentError(error));
    }
}

function* onHospitalEvaluationProduction(data) {
    try {
        const response = yield call(onHospitalEvaluationProductionAsync, data.payload);
        yield put(HospitalEvaluationProductionSuccess(response.data));
    } catch (error) {
        yield put(HospitalEvaluationProductionError(error));
    }
}

function* onHospitalEvaluationAvailability(data) {
    try {
        const response = yield call(onHospitalEvaluationAvailabilityAsync, data.payload);
        yield put(HospitalEvaluationAvailabilitySuccess(response.data));
    } catch (error) {
        yield put(HospitalEvaluationAvailabilityError(error));
    }
}


export default function* rootSaga() {
    yield all([
        fork(watchHospitalEvaluationList),
        fork(watchHospitalEvaluationDestination),
        fork(watchHospitalEvaluationArea),
        fork(watchHospitalEvaluationJob),
        fork(watchHospitalEvaluationCapacityInstall),
        fork(watchHospitalEvaluationInfrastructure),
        fork(watchHospitalEvaluationHumanTalent),
        fork(watchHospitalEvaluationProduction),
        fork(watchHospitalEvaluationAvailability),
        fork(watchHospitalEvaluationAdd)
    ]);
}